import Type from './Type';
export function isIText(node) {
    return node.type === Type.Text;
}
export default isIText;    //# sourceMappingURL=isIText.js.map
